module.exports = __webpack_public_path__ + "static/media/76-roz-backyard.111fdb11.jpg";